import { init as initSentry } from '@sentry/react';

export function setupSentry(environment: string) {
    initSentry({
        dsn: 'https://1a3d98080b992a11e5ad4a39b66d4040@o4511059502759936.ingest.de.sentry.io/4512027377074256',
        environment,
        beforeSend: (event) => {
            event.user = {
                triedToLoginWithNonExistedEmail: sessionStorage.getItem('triedToLoginWithNonExistedEmail') === 'true',
            };

            return event;
        },
    });
}
